<template>
	<div 
		v-if="computedLane"
		class="lane"
		:class="computedLane.steps.length ? 'with--steps' : ''"
		>
		<div class="lane--label">
			<span class="caption-uppercase">{{ computedLane.label }}</span>
		</div>

		<div 
			v-for="step in computedLane.steps"
			:key="step.index"
			class="step step-card"
			:class="step.active ? 'active' : ''"	 
			:style="`--data-pos-width: ${ (step.order - step.i ) * 360 + 40 }px; --data-length: ${ Array.from(lane.steps).length }`"
			:data-pos="step.order"
			>
			<div 
				class="step-card-inner Card p-3 card elevation-1" 
				:id="step.default ? 'start' : `next-${step.order}`"
				:data-pos="step.order"
				:data-clickable="step.clickable_el ? 'true' : 'false'" 
				:data-clickable-url="step.clickable_el ? step.clickable_el.url : null"
			>
				<div class="card--title">{{ step.label }}</div>
					
				<div 
					class="card--footer card--action-buttons"
					v-if="step.status_actions && step.status_actions_rendered"
					>
					<!-- <pre>{{ step.status_actions }}</pre> -->
					<ButtonsComponent
						:statusActionsRendered="step.status_actions_rendered"
						/>
	        	
	        	</div>
			</div>
		</div>
	</div>
</template>

<script>
import ButtonsComponent from '@vueapp/components/process-maps/ButtonsComponent.vue'

export default {
	name: 'ProcessMapLane',
	props: {
		lane: {
			type: Object,
			default: {},
			required: true
		}
	},
	components: { 
		ButtonsComponent 
	},
	data() {
		return {

		}
	},
	computed: {
		computedLane() {
			if ( this.lane.steps ) {
				this.lane.steps = this.lane.steps.map( (item, i) => {
					item.i = i
					return item
				})

				return this.lane
			}
		}
	},
	methods: {
		
		getRedirectNode( action_btn ) {
            if ( ! action_btn.result_event ) return null
            if ( 'close-module' == action_btn.result_event ) {
                return 'close-module'
            }
            return decodeURI(action_btn.result_event)
		}
	}
}
</script>